<template>
  <img v-if="hidden === false" style="width:80px; cursor: pointer" :src="i18n_locale_img" :alt="$i18n.locale"
       @click="toggleLocale"/>
</template>

<script>
import { FEATURE_HIDE_LANGUAGE_SELECT } from '@/store/key_value'

export default {
  name: 'I18nDropDown',
  data () {
    return {
      // 언어 선택을 숨기는 서버인지 (null = 서버 설정 조회 전, 그동안은 숨긴다)
      hidden: null
    }
  },
  async created () {
    try {
      this.hidden = await this.$store.dispatch('keyValue/IS_FEATURE_ENABLED', FEATURE_HIDE_LANGUAGE_SELECT)
    } catch (e) {
      this.hidden = false
    }

    // 언어 선택을 숨기는 서버에서는 예전에 고른 언어가 남아 있어도 바꿀 수 없으므로 한국어로 되돌린다.
    // 로케일 뒷부분(업종: _maot, _construct 등)은 그대로 둔다
    const _tempList = (this.$i18n.locale || '').split('_')
    if (this.hidden && _tempList[0] !== 'ko' && _tempList[1]) {
      const locale = `ko_${_tempList[1]}`
      this.$i18n.locale = locale
      localStorage.setItem('i18n_locale', locale)
    }
  },
  computed: {
    i18n_locale_img () {
      // Use below code to dynamically fetch image instead of if-else
      // NOTE: We used if-else because laravel throws error in 'yarn prod'.
      // If you are not using laravel + Vue, you can use below code to dynamically get image
      // return require(`@/assets/images/flags/${this.$i18n.locale}.png`)

      const locale = this.$i18n.locale
      const _tempList = locale.split('_')
      if (_tempList[0] === 'ko') {
        return require('@/assets/images/icon/icon-toggle-ko.svg')
      } else {
        return require('@/assets/images/icon/icon-toggle-en.svg')
      }
    }
  },
  methods: {
    async updateLocale (locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale
        await localStorage.setItem('i18n_locale', locale)
        await location.reload()
      }
    },

    toggleLocale () {
      const locale = this.$i18n.locale
      const _tempList = locale.split('_')
      if (_tempList[0] === 'ko') {
        this.updateLocale(`en_${_tempList[1]}`)
      } else {
        this.updateLocale(`ko_${_tempList[1]}`)
      }
    }
  }
}
</script>
